import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CustomDateModel} from "../../../../../modules/common/custom-date/entity/custom-date.model";

@Component({
  selector: 'app-custom-date-field',
  template: `
    <app-summary-field [label]="label">
      <span *ngIf="from && !to">
        <span>Depuis </span><ng-container [ngTemplateOutlet]="customDateTpl"
                                          [ngTemplateOutletContext]="{customDate:from}"></ng-container>
      </span>
      <span *ngIf="from && to">
        <ng-container *ngIf="sameDates else notTheSame">
          <ng-container [ngTemplateOutlet]="customDateTpl"
                        [ngTemplateOutletContext]="{customDate:from}"></ng-container>
        </ng-container>
          <ng-template #notTheSame>
            <span>De </span><ng-container [ngTemplateOutlet]="customDateTpl"
                                          [ngTemplateOutletContext]="{customDate:from}"></ng-container> jusque <ng-container
              [ngTemplateOutlet]="customDateTpl" [ngTemplateOutletContext]="{customDate:to}"></ng-container>
          </ng-template>
      </span>
      <span *ngIf="!from && to">
        <span>Terminé depuis </span> <ng-container [ngTemplateOutlet]="customDateTpl"
                                                   [ngTemplateOutletContext]="{customDate:to}"></ng-container>
      </span>
    </app-summary-field>

    <ng-template #customDateTpl let-customDate='customDate'>
      <span *ngIf="customDate.type.value === 'CUSTOM_DATE_TYPE_DATE'">le </span>{{customDate.date | moment : extractCustomDateFormat(customDate)}}
    </ng-template>
  `
})
export class CustomDateFieldComponent implements OnChanges{

  @Input() from: CustomDateModel;
  @Input() to: CustomDateModel;
  @Input() label: string;

  sameDates = false;

  ngOnChanges(changes: SimpleChanges): void {
    this.sameDates = this.from && this.to
        && this.from.date && this.to.date
      && this.from.type?.value === this.to.type?.value
      && this.from.date.isSame(this.to.date, "day");
  }



  extractCustomDateFormat(customDate: CustomDateModel):string {
    switch (customDate.type.value) {
      case 'CUSTOM_DATE_TYPE_MONTH_YEAR' : return 'MMMM YYYY';
      case 'CUSTOM_DATE_TYPE_YEAR' : return 'YYYY';
      case 'CUSTOM_DATE_TYPE_DATE' : return 'DD/MM/YYYY';
    }
  }
}
